<template>
  <div @click="addListener">
    <!-- <div class="pa-4">
      <strong>selected Items</strong>: {{ selectedItems.length }} --||--
      <strong>Data Items</strong> : {{ dataItems.length }} --||--
      <strong>SelectAll</strong>: {{ selectAll }} --||--
      <strong>SelectedAll</strong>: {{ selectedAll }} --||--
      <strong>TotalCount</strong>: {{ totalCount }}
    </div> -->
    <v-autocomplete
      :id="type"
      ref="customDropdown"
      v-model="selectedItems"
      :label="customTitle"
      :disabled="disabled"
      :items="dataItems"
      :item-text="itemText"
      return-object
      persistent-hint
      :placeholder="placeholder"
      clearable
      outlined
      flat
      multiple
      small-chips
      item-color="#03B6FC"
      :attach="attach"
      class="custom-selectbox background-white"
      :no-data-text="dataLoader?'Loading...':'No data available'"
      :class="type"
      :search-input.sync="search"
      :loading="dataLoader"
      :rules= "rules"
      @click:clear="clearItems"
      @input="addItem"
      @change="(abTitle ? null : stepHandler())"
      @blur="hideWarning == false ? warningMsg() : null;"
      :menu-props="{ ...menuProps }"
    >
      <template v-slot:selection="{ item, index }">
        <div v-if="index <= 3">
          <v-chip
            v-if="index < 3"
            chip-icon
            close
            color="rgba(0,107,175,0.2)"
            @click:close="removeItem(item); (abTitle ? null : stepHandler())"
          >
            
            <span v-if="type.includes('product')"> {{ item.item_id +' <-> '+ item.description }}</span>
            <span v-else-if="type.includes('field')">{{ item.name }}</span>
            <span v-else>{{ item.name }} ({{ type.includes('list') ? ($options.filters.nullToZero(item.subscribers)) : item.contacts_count }})</span>
          </v-chip>
          <span
            v-if="index === 3"
            class="#0076BD--text caption"
            style="color:#0076BD"
          >  
            <template v-if="!allowSelectAll">+{{ selectedItems.length - 3 }} </template>
            <template v-else>+{{ (selectAll || count ? count : selectedItems.length) - 3 }}</template>
            <span class="text-capitalize">{{ ' '+subtitle }}</span>
          </span>
        </div>
      </template>
      <template
        v-slot:prepend-item
      >
        <v-list-item
          v-if="dataLoader && $refs.customDropdown.filteredItems.length > 0"
          link
        >
          <v-list-item-content>
            <v-list-item-title>
              Loading...
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          v-if="dataItems.length > 1 && !isSearching && allowSelectAll"
        >
          <v-list-item-action>
            <v-checkbox
              v-model="selectAll"
              class="pa-0"
              color="#03B6FC"
              @change="(abTitle ? null : stepHandler()); selectAllItems(selectAll)"
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ selectAllText }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template
        v-if="type != 'suppress_segment' && !hideInfoText"
        v-slot:append-outer
      >
        <v-tooltip
          bottom
          color="rgba(0, 0, 0, 0.9)"
        >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span
            attach
            class="caption"
          >{{ infoText }}</span>
        </v-tooltip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
  import { campaignMixin } from '@/mixins/campaignMixin'
  import { $paginated, $products, $fields } from '@/services/'
  import unionBy from 'lodash/unionBy'
  export default {
    name: 'CustomDropdown',
    mixins: [campaignMixin],
    props: {
      type: String,
      label: String,
      disabled: Boolean,
      attach: {
        type: Boolean,
        default: true
      },
      lists: {
        type: Object,
        default: () => {},
      },
      campaign: {
        type: Object,
        default: () => {},
      },
      items: {
        type: Array,
        default: () => [],
      },
      hideInfoText :{
        type: Boolean,
        default: () => false
      },
      abPayload : {
        type: Object,
        default : () => {}
      },
      abTitle : {
        type: Boolean,
        default: () => false
      },
      hideWarning:{
        type: Boolean,
        default: false
      },
      rules:{
        type: Array,
        default : () => []
      },
      selectAllText:{
        type: String,
        default: () => 'Select All'
      },
      placeholder:{
        type: String,
        default: ''
      },
      allowSelectAll: {
        type: Boolean,
        default: true
      },
      abPayloadInSearch: {
        type: Boolean,
        default: false
      },
      menuProps: {
        type:Object,
        default:{}
      }
    },
    data () {
      return {
        infoText: '',
        debounceSearch: '',
        search: null,
        isSearching: false,
        isLoading: false,
        dataLoader: false,
        totalCount: 0,
        count: 0,
        dataItems: [],
        page: 1,
        enableScroll: true,
        selectAll: false,
        selectorClass: '',
        service: '',
        selection: {
          selectedItem: [],
          unselectedItem: [],
        },
        selectedItems: this.items,
        loadMore : true,
        listenerAdd : false,
        loadMoreItem : false
      }
    },
    computed: {
      itemText(){
        return item => {
          if(this.type.includes('product')){
            return item.item_id +' <-> '+item.description;
          } else if (this.type.includes('field')) {
            return item.name;
          } else {
            return item.name +' ('+ (this.type.includes('list') ? (this.$options.filters.nullToZero(item.subscribers)) : item.contacts_count) + ')'
          }
        }
      },
      subtitle () {
        if(this.type === 'subscription-list')
          return 'list' + (this.selectedItems.length > 4 ? 's' : '')
        else
          return this.type.split('_').join(' ') + (this.selectedItems.length > 4 ? 's' : '')
      },
      paramsObj () {
        let params = {
          list_type: (this.type === 'list' || this.type === 'subscription-list') ? 'normal' : undefined,
          page: this.page,
          per_page: 10,
          no_folder: true,
          name: this.search
        }
        if(this.campaign && this.campaign.brand_id && this.type === 'list'){
          params.brand_id = this.campaign.brand_id;
        }
        return params
      },
      contacts: {
        get () { return this.$store.state.campaign.contacts },
        set (value) { this.$store.state.campaign.contacts = value },
      },
      customTitle () {
        const length = (this.selectAll || this.count) ? this.count : this.selectedItems.length
        if (length > 1) {
          let lastChar = this.label.substr(this.label.length - 1);
          if(lastChar === '*'){
            return this.label.substr(0, this.label.length - 2) + 's * (' + length + ')'
          }
          else{
            return this.label + 's (' + length + ')'
          } 
        } else {
          return this.label + (this.abTitle ? 's' : '') + ' (' + length + ')'
        }
      },
      selectedAll:{
        cache: false,
        get(){
          return (this.lists && this.lists.select_all)
        }
      }
    },
    watch: {
      selectAll(newVal, oldVal) {
        if((!newVal && oldVal) || newVal) document.getElementById(this.type).focus()
      },
      search (val) {
        if (val) {
          this.isLoading = true
          this.isSearching = true
          this.dataLoader = '#03b6fc'
          if(this.debounceSearch){
            clearTimeout(this.debounceSearch)
          }
          this.debounceSearch = setTimeout(() => {
            this.loadMore = true;
            this.page = 1;
            let params = {
              page: this.page,
              per_page: 10,
              list_type: (this.type === 'list' || this.type === 'subscription-list') ? 'normal' : undefined,
              name: val,
              no_folder: true
            }
            if(this.campaign && this.campaign.brand_id && this.type === 'list'){
              params.brand_id = this.campaign.brand_id
            }
            this.service({
              params:this.abPayloadInSearch ? {...params, ...this.abPayload} : {...params}
            }).then(response => {
              let responseData
              if (this.type.includes('list') || this.type.includes('subscription-list')) {
                responseData = response.data.data.lists
              } else if (this.type.includes('segment')) {
                responseData = response.data.data.segments
              }  else if (this.type.includes('product')) {
                responseData = response.data.data.products
              } else if (this.type.includes('field')) {
                responseData = response.data.data
              }
              this.dataItems = unionBy(this.dataItems, responseData, "id")
              if (this.selectAll) {
                this.selectedItems = [...new Set(this.dataItems)]
              }
              if (this.type.includes('field')) {
                if (response.data.meta.page >= response.data.meta.total_pages) { 
                  this.loadMore = false; 
                }
              } else if (response.data.data.meta.page >= response.data.data.meta.total_pages) {
                this.loadMore = false;
              }
            }).catch(err => {
              console.log(err)
            })
              .finally(() => {
                this.isLoading = false
                this.dataLoader = false
                this.adjustWidth()
              })
          }, 500)
        } else {
          this.page = 0 ;
          this.getMoreItems();
          this.isSearching = false
        }
      },
      selectedItems (newVal, oldVal) {
        this.setItems()
        if (this.type === 'list') this.updateTextFields()
        if (newVal.length === 0) {
          this.count = 0
          this.lists.select_all = false
        }
        /**
         * click on checkbox of any item
         * count takes 2 miliseconds to update
         * so this timeout update the select all based on the following condition
         */
        setTimeout(() => {
          if(this.selectedAll && this.selectedItems.length == this.dataItems.length)
            this.selectAll  = true
          else
            this.selectAll  = false
        }, 200);

        if (newVal.length < oldVal.length && this.count && this.totalCount >= this.count && !this.loadMoreItem) 
          this.count = this.count - 1
        if (newVal.length > oldVal.length && this.count && this.totalCount > this.count && !this.loadMoreItem) 
          this.count = this.count + 1

        if (newVal.length > oldVal.length && !this.selectAll && newVal.length === this.totalCount) {
          this.count = this.totalCount
          oldVal.filter(x => {
            const index = newVal.findIndex(val => val.id === x.id)
            if (index < 0) {
              this.lists.ids.push(x.id)
            }
          })
        }
        if (this.lists.select_all && newVal.length < oldVal.length) {
          oldVal.filter(x => {
            const index = newVal.findIndex(val => val.id === x.id)
            if (index < 0) {
              this.lists.ids.push(x.id)
            }
          })
        }
        if(newVal.length == 4 && this.selectedAll){
          this.getMoreItems();
        }
        this.loadMoreItem = false
        this.$emit("update:items", newVal)
      },
    },
  created() {
      if (this.type.includes('list') || this.type.includes('subscription-list'))
        this.service = $paginated.getList
      else if (this.type.includes('segment'))
        this.service = $paginated.getSegment
      else if (this.type.includes('product'))
        this.service = $products.fetch
      else if (this.type.includes('field'))
        this.service = $fields.fetch
    },
    mounted () {
      this.dataLoader = '#03b6fc'
      this.$store.state.campaign.dropdownLoader = true
      this.loadMore = true;
      this.service({
        params: {...this.paramsObj,...this.abPayload},
      }).then(response => {
        this.setData()
        this.dataItems = [...this.selectedItems]
        this.count = this.dataItems.length;
        if (this.type.includes('list') || this.type.includes('subscription-list')) {
          this.dataItems = unionBy(this.dataItems,response.data.data.lists, "id")
        } else if (this.type.includes('segment')) {
          this.dataItems = unionBy(this.dataItems,response.data.data.segments, "id")
        } else if (this.type.includes('product')){
          this.dataItems = unionBy(this.dataItems,response.data.data.products, "id")
        } else if (this.type.includes('field')) {
          this.dataItems = unionBy(this.dataItems,response.data.data, "id")
        }
        if (this.type.includes('field')) {
          if (response.data.meta.page >= response.data.meta.total_pages) { 
            this.loadMore = false; 
          }
        } else if (response.data.data.meta.page >= response.data.data.meta.total_pages) {
          this.loadMore = false;
        }
          

        this.totalCount = this.type.includes('field')? response.data.meta.count : response.data.data.meta.count
        this.$emit('total-count', this.totalCount);
      }).finally(() => {
        this.dataLoader = false
        this.setSelectAllData()
        if (this.type === 'suppress_segment') {
          this.$store.state.campaign.dropdownLoader = false
        }
        this.adjustWidth()
      })
    },
    methods: {
      warningMsg() {
        setTimeout(() => {
          this.contactInfo(this.selectedItems, this.lists.select_all, this.type)
        })
        this.loadMore = true;
      },
      adjustWidth() {
        if (!this.attach) {
          const ele = document.querySelector('.v-application > .v-autocomplete__content')
          if (!ele) return;
          const width = ele.style['min-width']
          document.querySelector('.v-application > .v-autocomplete__content').style['max-width'] = width;
        }
      },
      addListener() {
        if (this.listenerAdd) return;
        
        this.selectorClass = this.attach ? '.' + this.type + ' .v-autocomplete__content' : ' .v-autocomplete__content';
        var el = document.querySelector(this.selectorClass)
        /** add scroll event **/
        if (el) { 
           el.addEventListener('scroll', this.onScroll)
           this.listenerAdd = true;
        }
      },
      onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
        if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
          if (this.loadMore) { 
            this.getMoreItems(); 
          }
        }
      },
      setData () {
        switch (this.type) {
          case 'list':
            this.infoText = this.hideInfoText ? '' : 'Select one or more contact lists to send the campaign email.'
            this.selectedItems = [...this.contacts.lists]
            break
          case 'suppress_list':
            this.infoText = this.hideInfoText ? '' : 'Select one or more contact lists to exclude from sending the campaign email.'
            this.selectedItems = [...this.contacts.suppressed_lists]
            break
          case 'segment':
            this.infoText = this.hideInfoText ? '' : 'Select one or more contact segments to send the campaign email.'
            this.selectedItems = [...this.contacts.segments]
            break
          case 'suppress_segment':
            this.selectedItems = [...this.contacts.suppressed_segments]
            break
          case 'send_test_list':
            this.infoText = this.hideInfoText ? '' : 'The contacts in the selected lists will be sent test email. The lists selected here will have no impact on lists selected in Step 2.'
            this.selectedItems = [...this.contacts.send_test_lists]
            break
        }
      },
      setSelectAllData () {
        if (this.selectedItems.length === this.totalCount && this.totalCount > 0 && this.lists !== undefined) {
          if(this.campaign.brand_id){
            this.lists.select_all = false
            this.lists.ids = this.selectedItems.map(item => item.id)
          }
          else{
            this.lists.select_all = true
            this.lists.ids = []
          }
          this.selectAll = true
          this.count = this.totalCount
        }
      },
      setBrandedList () {
        let params = {
          page: this.page,
          per_page: 10,
          list_type: this.type === 'list' ? 'normal' : undefined,
          no_folder: true
        }
        if(this.campaign && this.campaign.brand_id && this.type === 'list'){
          params.brand_id = this.campaign.brand_id
        }
        this.service({
          params,
        }).then(response => {
          this.dataItems = this.getSelectedList(this.selectedItems, response.data.data.lists)
          this.totalCount = response.data.data.meta.count
        })
      },
      updateTextFields () {
        if (!this.selectAll && this.selectedItems.length > 0 && this.campaign.campaignAction !== "edit" && this.campaign.campaignAction !== "duplicate") {
          const endList = this.selectedItems[this.selectedItems.length - 1]
          this.campaign.from_name = endList.from_name ? endList.from_name : this.campaign.from_name
          this.campaign.from_email = endList.from_email ? endList.from_email : this.campaign.from_email
          this.campaign.reply_to = endList.reply_to_email ? endList.reply_to_email : this.campaign.reply_to
          this.campaign.address = endList.address ? endList.address : this.campaign.address
          this.campaign.language = endList.language ? endList.language : this.campaign.language
        }
        else if(this.campaign.campaignAction === "edit" || this.campaign.campaignAction === "duplicate"){
          this.campaign.campaignAction = ''
        }
      },
      updateLists () {
        this.selectAll = false
        this.selectedItems = []
        this.lists.ids = [];
        this.page = 1
        
        if (this.type.includes('list') || this.type.includes('subscription-list')
        || this.type.includes('product')
        )
          this.selectedItems = []

        this.service({
          params: {...this.paramsObj,...this.abPayload},
        }).then(response => {
          this.dataItems = response.data.data.lists
          this.totalCount = response.data.data.meta.count
          this.loadMore = true;
          if(response.data.data.meta.page >= response.data.data.meta.total_pages)
            this.loadMore = false;
        })
        this.$store.state.campaign.oldBrandId = this.campaign.brand_id
      },
      setItems () {
        switch (this.type) {
          case 'list':
            this.contacts.lists = [...this.selectedItems]
            break
          case 'suppress_list':
            this.contacts.suppressed_lists = [...this.selectedItems]
            break
          case 'segment':
            this.contacts.segments = [...this.selectedItems]
            break
          case 'suppress_segment':
            this.contacts.suppressed_segments = [...this.selectedItems]
            break
          case 'send_test_list':
            this.contacts.send_test_lists = [...this.selectedItems]
            break
        }
      },
      addItem (event) {
        if (!this.lists.select_all) {
          this.lists.ids = event.map(val => val.id)
        }
      },
      clearItems () {
        this.selectAll = false
        this.selectedItems = []
        this.lists.ids = []
        this.lists.select_all = false
      },
      removeItem (val) {
        const index = this.selectedItems.findIndex(item => item.id === val.id)
        if (index >= 0) {
          this.selectedItems.splice(index, 1)
          this.selectAll = false
          this.lists.ids = this.lists.ids.filter(value => value !== val.id)
        }
        if(this.count) --this.count
        if (this.lists.select_all){ 
          this.lists.ids.push(val.id);
        }
        this.addListener();
      },
      selectAllItems ($event) {
        this.selectAll = $event
        this.lists.select_all = $event
        this.lists.ids = []
        if (this.selectAll) {
          this.count = this.totalCount
          this.selectedItems = [...this.dataItems]
        } else {
          this.count = 0
          this.selectedItems = []
        }
        this.$forceUpdate();
      },
      getMoreItems () {
        if(this.dataLoader) return;
        this.dataLoader = '#03b6fc'
        ++this.page
        this.service({
          params: {...this.paramsObj,...this.abPayload}
        }).then(response => {
          let responseData
          if (this.type.includes('list') || this.type.includes('subscription-list')) {
            responseData = response.data.data.lists
          }
          if (this.type.includes('segment')) {
            responseData = response.data.data.segments
          }
          if (this.type.includes('product')) {
            responseData = response.data.data.products
          }
          if (this.type.includes('field')) {
            responseData = response.data.data
          }
          if (responseData.length === 0) {
            this.enableScroll = false
          } else {
            if(this.selectedAll){
              this.loadMoreItem = true
              responseData.forEach(item => {
                let index = this.dataItems.findIndex(x => x.id == item.id)
                if(index == -1){
                  this.selectedItems.push(item);
                }
              });
            }
            this.dataItems = unionBy(this.dataItems, responseData, "id")
          }
          this.loadMore = true;
          if (this.type.includes('field')) {
            if (response.data.meta.page >= response.data.meta.total_pages) { 
              this.loadMore = false; 
            }
          } else if (response.data.data.meta.page >= response.data.data.meta.total_pages) {
            this.loadMore = false;
          }
        })
        .finally(() => {
          this.dataLoader = false
          this.adjustWidth()
        })
      },
      getSelectedList (selected,responseData) {
        let selectedListIds = selected.map(item => item.id);
        let responseDataIds = responseData.map(item => item.id);
        let diff = selectedListIds.map((id, index) => {
        if (responseDataIds.indexOf(id) < 0) {
            return selected[index];
        }
        }).concat(responseDataIds.map((id, index) => {
        if (selectedListIds.indexOf(id) < 0) {
            return responseData[index];
        }
        })).filter(item => item != undefined);
        return [...selected , ...diff];
      },
    },
  }
</script>
